/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import toast from "react-hot-toast";

import { VApplication } from "../../../application";
import { pretty } from "@vlinder-web/utils-react";
import { AppNavigatorService } from "../../appNavigatorService";
import { UPLOAD_FILE, Update_Band } from "../graphql";
import { StorageModule } from "@vlinder-web/storage-module-react";
import { Update_Cities } from "../graphql/updateCities.mutate";
const is = require("is_js");

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};
const getSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.AppNavigatorService") as AppNavigatorService;
};

export interface IUpdateCitiesMethods extends IPluginMethodMap {
  getUpdateCities(args: any): Promise<any>;
}

export class UpdateCitiesService implements IAgentPlugin {
  readonly methods: IUpdateCitiesMethods;

  constructor() {
    this.methods = {
      getUpdateCities: this.getUpdateCities.bind(this),
    };
  }

  async getUpdateCities(args: any) {
    console.log(`service args`, pretty(args));
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");

    try {
      if (client) {
        const res = await client.mutate({
          mutation: Update_Cities,
          variables: {},
          fetchPolicy: "no-cache",
        });
        if (res?.data) {
          return {
            data: res?.data,
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}
